import { m } from 'framer-motion';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useTranslation } from 'src/hooks/use-translation';

import { varBounce, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

export function SomethingWentWrongView({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation('error', { keyPrefix: 'something-went-wrong' });

  return (
    <Container
      maxWidth="lg"
      sx={{ textAlign: 'center', justifyContent: 'center', m: 'auto' }}
      data-testid="something-went-wrong-view"
    >
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            {t('title')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>{t('description')}</Typography>
        </m.div>

        <Button color="primary" onClick={onRetry} size="large" variant="contained" sx={{ mt: 2 }}>
          {t('reload')}
        </Button>
      </MotionContainer>
    </Container>
  );
}
